import Application from '@/store/Models/Application'
export default {

    // From MyLeads
    getApplications(agent_code, filters, options) {
        Application.commit((state) => {
            state.loading = true
        })
        var params = {
            ...options,
            ...filters
        }
        this.cancelQRequest("getApplicationsQ");
        return this.getRequest('/api/private/applications/' + agent_code, params, "getApplicationsQ").then(function(json) {
            if (typeof json.meta == 'undefined') {
                return json;
            }
            Application.commit((state) => {
                state.loading = false
                state.total = json.meta.total
                if (json.meta.filters) {
                    state.availableFilters = json.meta.filters
                }
            })
            return json;
        })
    },
    getSubmittedApplications(agent_code, filters, options) {
        Application.commit((state) => {
            state.loading = true
        })
        const params = {
            ...options,
            ...filters
        }
        this.cancelQRequest("getSubmittedApplications");
        return this.getRequest('/api/private/new_business/application_audit/' + agent_code, params, "getSubmittedApplications")
			.then((json) => {
				Application.commit((state) => {
					state.loading = false
					state.total = json.meta?.total || json.data.length
					if (json.filters) {
						state.availableFilters = json.filters
						state.filter_keys = Object.keys(json.filters)
					}
				})
				return json
			})
    },

	async getApplicationPdf (link) {
        if (!link) {
            return Promise.resolve({
				error: true,
				msg: 'Link is not defined',
			})
        }

        const token = await this.config()
		
        // const link = `/api/private/new_business/application_submission/${id}/view_application_pdf/${timestamp}/${hash}`
        return fetch(link, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })
        .then((response) => {
			if (!response.ok) {
				throw new Error(response.statusText)
			}
			const reader = response.body.getReader()
			return new ReadableStream({
				start (controller) {
					function pump () {
						return reader.read().then(({ done, value }) => {
							if (done) {
								controller.close()
								return
							}
							controller.enqueue(value)
							return pump()
						})
					}
					return pump()
				},
			})
		})
		.then((stream) => new Response(stream))
		.then((response) => response.blob())
		.then((blob) => URL.createObjectURL(blob))
		.then((url) => url)
		.catch((err) => ({ error: true, msg: err.message }))
	},
    updateApplication(agent_code, application) {
		// TODO wait backend task
		return new Promise((resolve) => {
			setTimeout(() => {
				resolve(application.isNotDuplicate ? { success: true } : {
					success: false,
					duplicate: { ...application },
					errors: {
						ApplicationPDFURL: [
							"The PDF URL field is required."
						]
					}
				});
			}, 2000);
		});
        // return this.postRequest('/api/private/new_business/application_submission/' + agent_code, application)
    },
    checkCarrier(agent_code, carrierId) {
        return this.getRequest('/api/private/new_business/writing_numbers_active/' + agent_code, {
			CarrierID: carrierId,
		})
    },
}
